<template>
  <div class="timeCounter">
    <span>{{countDownList[0]}}</span>
    :
    <span>{{countDownList[1]}}</span>
    :
    <span>{{countDownList[2]}}</span>
  </div>
</template>
<script>
// 日期范围选择弹窗
export default {
  name: 'timeCounter',
  components: {},
  props: {
    // 弹窗是否显示
    end: {
      default: new Date().getTime()
    }
  },
  data () {
    return {
      countDownList: ['00', '00', '00']
    };
  },
  computed: {},
  mounted () {
    this.countDown();
    // this.getList();
  },
  methods: {
    timeFormat (param) {
      return param < 10 ? '0' + param : param;
    },
    countDown (it) {
      let interval = setInterval(() => {
        // 获取当前时间，同时得到活动结束时间数组
        let newTime = new Date().getTime(); // 对结束时间进行处理渲染到页面
        let endTime = new Date(this.end).getTime();
        let obj = null; // 如果活动未结束，对时间进行处理
        if (endTime - newTime > 0) {
          let time = (endTime - newTime) / 1000; // 获取天、时、分、秒
          let hou = parseInt((time % (60 * 60 * 24)) / 3600);
          let min = parseInt(((time % (60 * 60 * 24)) % 3600) / 60);
          let sec = parseInt(((time % (60 * 60 * 24)) % 3600) % 60);
          obj = {
            hou: this.timeFormat(hou),
            min: this.timeFormat(min),
            sec: this.timeFormat(sec)
          };
        } else {
          // 活动已结束，全部设置为'00'
          obj = {
            hou: '00',
            min: '00',
            sec: '00'
          };
          clearInterval(interval);
        }
        this.countDownList = [obj.hou, obj.min, obj.sec];
        // obj.day + '天' + obj.hou + '时' + obj.min + '分' + obj.sec + '秒';
      }, 1000);
    }
  }
};
</script>
<style lang="less" scoped>
.timeCounter {
  display: inline-block;
}
</style>
